<div class="title" #title>
  <div class="container container-max-width">
    <div>
      <h4>View Demands</h4>
      <p>View blueprints assigned to the project</p>
    </div>
  </div>
</div>
<div class="container container-content container-max-width" (window:resize)="onResize()"
  [style.height]="containerHeight">
  <div class="landing-main">
    <div class="top-panel" style="width: 100%">
      <ng-select name="Project" bindLabel="Label" [(ngModel)]="selectedProject" (ngModelChange)="onProjectChanged()"
        placeholder="Select a project" [items]="projects" groupBy="ProjectStatus" required>
      </ng-select>
    </div>

    <div>
      <grid-filter-pills [gridApi]="gridApi" *ngIf="gridApi"></grid-filter-pills>
      <ag-grid-angular #agGrid id="ViewGrid" style="width: 100%; height: 540px" class="ag-theme-balham"
        [gridOptions]="gridOptions" [rowData]="rowData" [pagination]="true" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
</div>